export default class Atividade {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.projetoId = 0;
        this.nome = '';
        this.dataInicio = '';
        this.dataTermino = '';
        this.custoEstimado = 0;
        this.itens = [];

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.projetoId = model.projetoId;
        this.nome = model.nome;
        this.dataInicio = new Date(model.dataInicio).yyyymmdd();
        this.dataTermino = model.dataTermino ? new Date(model.dataTermino).yyyymmdd() : null;
        this.custoEstimado = model.custoEstimado;
        this.itens = model.itens;
    }
}